// extracted by mini-css-extract-plugin
export default {"wrapper":"VDQwVsfbmT","image":"_24BKoJHgm","title":"TLN3pnlTyO","description":"E1ij7otaSD","links":"kH31Et3ba9","link":"Dmxop51Uex"};